import axios from "axios";
export const documentTemplateApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/document-template`,
});
